import { Box, Container, Typography, useTheme } from "@mui/material";
import './FAQs.scss';
import WebBanner from "../../layouts/WebLayout/components/WebBanner/WebBanner";
import Faq from '../../assets/images/faq.svg';
import Faqs from "../Home/components/Faqs/Faqs";

const FAQs = () => {
    const theme = useTheme()

    return (
        <>
            <WebBanner
                title="FAQs"
                subtitle="Frequently Asked Questions"
                image={Faq}
            />
            <Container maxWidth="xl"> 
                <Box sx={{marginBottom: "10rem"}}>
                    <Faqs  bgColor="transparent" 
                    borderStyle={theme.palette.mode == "light" ? "1px solid #E3E3E3" : "none"} 
                    />
                </Box>
            </Container>
        </>
    )
};

export default FAQs